import { ReactNode } from 'react'

import { KW } from './theme'

interface Props {
  children: ReactNode
  icon?: ReactNode
  tone?: 'teal' | 'green' | 'amber'
}

const TONES = {
  teal: { color: KW.teal500, background: KW.soft, border: KW.softBorder },
  green: { color: '#1f5138', background: KW.greenBg, border: '#bfe6d2' },
  amber: { color: KW.amber, background: KW.amberBg, border: '#f2e2c2' },
}

/** Tinted inline notice ("Remembered: 'ABC' = …", confirmations, warnings). */
const NoticeStrip = ({ children, icon, tone = 'teal' }: Props) => {
  const palette = TONES[tone]
  return (
    <div
      className="mt-[10px] flex items-center gap-[7px] rounded-lg px-[10px] py-[7px] text-[11.5px]"
      style={{
        color: palette.color,
        background: palette.background,
        border: `1px solid ${palette.border}`,
      }}
    >
      {icon}
      <span>{children}</span>
    </div>
  )
}

export default NoticeStrip
